import {Flex, Grid, Icon, Stack, Text, useColorModeValue, useToast} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import React, {useEffect, useState} from "react";
import {columnsConversationOverView} from "variables/columnsData";
import ConversationsTableRefactored from "./Components/ConversationsTableRefactored";
import {getConversations} from "../../../api/lawdiskService";
import LoadingData from "../../../components/Loading/LoadingData";
import RecordWidget from "./Components/RecordWidget";
import {getUser} from "../../../api/userService";

function DefaultRefactor() {
  const toast = useToast();
  const textColor = useColorModeValue("gray.700", "white");
  const [conversationData, setConversationData] = useState([]);
  const [isLoadingConversationData, setIsLoadingConversationData] = useState(true);
  const [errorLoadingData, setErrorLoadingData] = useState(false);
  const [userData, setUserData] = useState(null);
  const [hasFreeMinutes, setHasFreeMinutes] = useState(0);

  useEffect(() => {
    const fetchConversationData = async () => {
      try {
        const response = await getConversations();
        if (response.status === 500) {
          throw new Error("Failed to fetch conversation");
        }
        setConversationData(response);
      } catch (error) {
        setConversationData([]);
        setErrorLoadingData(true);
      } finally {
        setIsLoadingConversationData(false);
      }
    };

    const fetchUser = async () => {
      const user = await getUser();
      setUserData(user);
    }

    const response = fetchConversationData();
    const userResponse = fetchUser();
  }, []);


  useEffect(() => {
    if (errorLoadingData === true) {
      toast({
        title: "Fout bij het ophalen van uw notulen",
        description: 'Er ging wat mis bij het ophalen van uw notulen, mocht dit probleem zich voorblijven doen neem dan contact op met support.',
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
    }
  }, [errorLoadingData])

  return (
    <Flex direction="column" pt={{sm: "125px", lg: "75px"}}>
      <Grid
        templateColumns={{sm: "1fr", md: "1fr 1fr", lg: "1fr 1fr 2fr"}}
        templateRows="1fr"
        gap="24px"
        mb="24px"
      >
        <Stack direction="column" spacing="24px">
          <RecordWidget user={userData} />
        </Stack>
      </Grid>
      <Card px="0px">
        <CardHeader px="22px" mb="24px">
          <Flex direction="column">
            <Text color={textColor} fontSize="lg" fontWeight="bold" mb="6px">
              Notulenbeheer
            </Text>
          </Flex>
        </CardHeader>
        {
          isLoadingConversationData ? (
            <Flex>
              <LoadingData/>
            </Flex>
          ) : (
            <CardBody>
              <ConversationsTableRefactored tableData={conversationData} columnsData={columnsConversationOverView}/>
            </CardBody>
          )
        }
      </Card>
    </Flex>
  )
    ;
}

export default DefaultRefactor;
